import { RouteObject } from 'react-router-dom'

import PrivateRoute from 'component/common/private-route'
import { FEATURE } from 'constants/feature'
import PropertyActivitiesList from 'pages/property-activities'
import PropertyActivitiesDetail from 'pages/property-activities/detail'
import { PAGES } from 'routes/index'

export const propertyActivitiesRoutes: RouteObject[] = [
  {
    path: PAGES.PROPERTY_ACTIVITIES,
    element: (
      <PrivateRoute feature={FEATURE.PROPERTY_ACTIVITIES}>
        <PropertyActivitiesList />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.PROPERTY_ACTIVITIES_DETAIL,
    element: (
      <PrivateRoute feature={FEATURE.PROPERTY_ACTIVITIES}>
        <PropertyActivitiesDetail />
      </PrivateRoute>
    ),
  },
]
